import { withTheme } from "styled-components";
import DefaultTable, {
  ActionButtons,
  Line,
} from "../../../ui-library/CustomTable/DefaultTable";
import React from "react";
import { Dropdown } from "react-bootstrap";
import TableDropDown from "../../../ui-library/TableDropDown/TableDropDown";
import CustomChip from "../../../ui-library/CustomChip/CustomChip";
import ButtonDropdown from "../../../ui-library/ButtonDropdown/ButtonDropdown";
import { useTranslation } from "react-i18next";
import { decimalPlaces, roundMealValue } from "../../../../helpers/mealsHelper";

const FavoritesTable = (props) => {
  const {
    getData,
    searchedParams,
    totalitems,
    favorites,
    canEditFavorites,
    canViewDetailFavorites,
    canCreateFavorites,
    onEdit,
    onView,
    loading,
    dietDiaryOptions,
    canRemoveFavorites,
    onDelete,
  } = props;

  const { t } = useTranslation();

  const defaultProps = {
    headers: [
      { label: t("appText.name") },
      { label: t("appText.description") },
      { label: t("appText.dietDiary.calories") },
      { label: t("appText.dietDiary.fats") },
      { label: t("appText.dietDiary.longChainFats") },
      { label: t("appText.dietDiary.mediumChainFats") },
      { label: t("appText.options") },
    ],
    hasSearch: false,
    haspagesizefilter: true,
    haspagination: true,
    searchedParams,
    totalitems,
    loading,
    getData,
  };

  const getDropDownItems = () => {
    const dropDownMenuItems = {
      EDIT: {
        text: t("appText.edit"),
        callBack: (favorite) => onEdit(favorite),
        id: 1,
        isVisible: canEditFavorites,
      },
      VIEW_DETAILS: {
        text: t("appText.viewDetails"),
        callBack: (favorite) => onView(favorite),
        id: 2,
        isVisible: canViewDetailFavorites,
      },
      REMOVE: {
        text: t("appText.favorites.remove"),
        callBack: (favorite) => onDelete(favorite),
        id: 3,
        isVisible: canRemoveFavorites,
      },
    };

    return Object.values(dropDownMenuItems);
  };

  return (
    <DefaultTable {...defaultProps}>
      <ActionButtons>
        {canCreateFavorites && dietDiaryOptions && (
          <ButtonDropdown
            size="sm"
            title={t("appText.addNew")}
            options={Object.values(dietDiaryOptions).sort(
              (a, b) => a.order < b.order
            )}
          />
        )}
      </ActionButtons>
      {favorites?.map((favorite, index) => (
        <Line key={`${favorite.favoriteId}-${index}`}>
          <span>
            <CustomChip text={favorite.name} />
          </span>
          <span>{favorite.description}</span>
          <span>{`${Number(roundMealValue(favorite.calories.value)).toFixed(
            decimalPlaces
          )}${favorite.calories.unit}`}</span>
          <span>{`${Number(roundMealValue(favorite.fats.value)).toFixed(
            decimalPlaces
          )}${favorite.fats.unit}`}</span>
          <span>{`${Number(
            roundMealValue(favorite.longChainFats.value || 0)
          ).toFixed(decimalPlaces)}${
            favorite.longChainFats.unit || "g"
          }`}</span>
          <span>{`${Number(
            roundMealValue(favorite.mediumChainFats.value || 0)
          ).toFixed(decimalPlaces)}${
            favorite.mediumChainFats.unit || "g"
          }`}</span>
          <TableDropDown>
            {getDropDownItems()
              .filter((dropDownItem) => dropDownItem.isVisible)
              .map((item, index) => (
                <Dropdown.Item
                  key={index}
                  bsPrefix="dropdown-item"
                  disabled={item.isDisabled}
                  onSelect={() => item.callBack(favorite)}
                >
                  {item.text}
                </Dropdown.Item>
              ))}
          </TableDropDown>
        </Line>
      ))}
    </DefaultTable>
  );
};

export default withTheme(FavoritesTable);
